<template id="dialogEditMapTmpl">
    <!-- FORM EDIT MAP START -->
    <v-dialog v-model="dialogEditMapIsOpen" v-if="map2edit != null" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card>
            <v-toolbar color="primary" dark>
                <v-btn icon dark v-on:click="closeEditMap()">
                    <v-icon>close</v-icon>
                </v-btn>
                <v-toolbar-title v-if="map2edit.sitemap_id != null">{{$t('lbl.map')}}: {{map2edit.map_name}}</v-toolbar-title>
                <v-toolbar-title v-else>{{$t('lbl.newMap')}}</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
               <v-form ref="editMapFrm" v-model="validMapFrm" lazy-validation>
                    <v-row no-gutters>
                        <v-col cols="12">
                            <v-text-field v-model="map2edit.map_name" :label="$t('lbl.mapName')" :rules="mapNameRules"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-col cols="12">
                            <v-text-field v-model="map2edit.map_link" :label="$t('lbl.mapLink')"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-col cols="12">
                            <v-switch v-model="map2edit.flags.active" :label="$t('lbl.active')"></v-switch>
                        </v-col>
                    </v-row>

                    <v-row no-gutters>
                        <v-col cols="12">
                            <v-select v-model="map2edit.map_asset_type" :items="assetTypeItems" :label="$t('lbl.mapAssetType')"></v-select>
                        </v-col>
                    </v-row>
                    
                    <!-- MAP ASSET -->
                    <v-row no-gutters v-if="map2edit.map_asset_type == 'threejs'">
                        <v-col cols="12">
                            <v-select v-model="map2edit.map_asset" :items="tjsobjlist" :label="$t('lbl.mapAssetThreeJs')"></v-select>
                        </v-col>
                    </v-row>
                    <v-row no-gutters v-if="map2edit.map_asset_type == 'render3d_basic'">
                        <v-col cols="12">
                            <v-select v-model="map2edit.map_asset" :items="s3dBasicItemslist" :label="$t('lbl.mapAssetRender3dBasic')"></v-select>
                        </v-col>
                    </v-row>
                    <v-row no-gutters v-if="map2edit.map_asset_type == 'render3d_pro'">
                        <v-col cols="12">
                            <v-text-field v-model="map2edit.map_asset" :label="$t('lbl.mapAssetRender3dPro')" :rules="mapAssetRules"></v-text-field>
                        </v-col>
                    </v-row>
					<v-row no-gutters v-if="map2edit.map_asset_type == 'image'">
                        <v-col cols="12">
                            <v-text-field v-model="map2edit.map_asset" :label="$t('lbl.mapAssetRenderImage')" :rules="mapAssetRules"></v-text-field>
                        </v-col>
						<v-col cols="12">
							Ex: http://www.closetech.it/tools/renderimage/taglierina.bmp
						</v-col>
                    </v-row>
                   
                    

                    <!-- MAIN OBJ POSITION -->
                    <div v-if="(map2edit.map_asset_type == 'threejs' || map2edit.map_asset_type == 'render3d_basic')">
                        <v-toolbar dark>
                            <v-toolbar-title>{{$t('lbl.mapMainObj')}}</v-toolbar-title>
                        </v-toolbar>
                        <v-row no-gutters>
                            <v-col cols="12" md="4">
                                <v-text-field type="number" v-model.number="map2edit.main_obj_pos_x" :label="$t('lbl.mapMainObjPosX')"></v-text-field>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-text-field type="number" v-model.number="map2edit.main_obj_pos_y" :label="$t('lbl.mapMainObjPosY')"></v-text-field>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-text-field type="number" v-model.number="map2edit.main_obj_pos_z" :label="$t('lbl.mapMainObjPosZ')"></v-text-field>
                            </v-col>

                            <v-col cols="12" md="4">
                                <v-text-field type="number" v-model.number="map2edit.main_obj_scale_x" :label="$t('lbl.mapMainObjScaleX')"></v-text-field>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-text-field type="number" v-model.number="map2edit.main_obj_scale_y" :label="$t('lbl.mapMainObjScaleY')"></v-text-field>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-text-field type="number" v-model.number="map2edit.main_obj_scale_z" :label="$t('lbl.mapMainObjScaleZ')"></v-text-field>
                            </v-col>

                            <v-col cols="12" md="4">
                                <v-text-field type="number" v-model.number="map2edit.main_obj_rotation_x" :label="$t('lbl.mapMainObjRotationX')"></v-text-field>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-text-field type="number" v-model.number="map2edit.main_obj_rotation_y" :label="$t('lbl.mapMainObjRotationY')"></v-text-field>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-text-field type="number" v-model.number="map2edit.main_obj_rotation_z" :label="$t('lbl.mapMainObjRotationZ')"></v-text-field>
                            </v-col>
                        </v-row>
                    </div>

                    
					<v-row no-gutters>
                        <v-col cols="12">
                            <v-text-field v-model="map2edit.map_db_mask_code" :label="$t('lbl.mapDbMaskCode')" ></v-text-field>
							{{$t('lbl.mapDbMaskCodeInfo')}}
                        </v-col>
                    </v-row>
                  
                    <v-row no-gutters>
                        <v-col cols="12">
                            <v-btn class="button-main" v-on:click="editMap()"><v-icon left dark>cloud_upload</v-icon>{{ $t('btn.save')}}</v-btn>
                        </v-col>
                    </v-row>
                </v-form>	
            </v-card-text>
        </v-card>	
    </v-dialog>
    <!-- FORM EDIT MAP END -->
</template>

<script>
import i18n from '@/i18n';
import {events} from '@/event-bus.js';
import constants from '@/ctConstants.js';

export default {
    i18n,
    data: () => ({
        dialogEditMapIsOpen: false,
        validMapFrm: false,
		mapNameRules: [
            v => !!v || i18n.t('err.fieldNotValid'),
            v => v.length > 0 || i18n.t('err.fieldNotValid')
        ],
        mapAssetRules: [
            v => !!v || i18n.t('err.fieldNotValid'),
            v => v.length > 0 || i18n.t('err.fieldNotValid')
        ],
        mapAssetTypeRules: [
            v => !!v || i18n.t('err.fieldNotValid'),
            v => v.length > 0 || i18n.t('err.fieldNotValid')
        ],
		assetTypeItems:[],
        tjsobjlist: [],
		s3dBasicItemslist: [],
    }),
    props: ['map2edit'],
    mounted() 
    {
        //=== STARTUP
        this.assetTypeItems = this.getMapAssetTypeItems();
        this.loadTjsObjList();
        this.loadS3dBasicItemList();
    },
    destroyed() 
    {

    },
    methods: {
        loadS3dBasicItemList()
		{
			var endpoint2go = constants.ENDPOINT_GATEWAY_S3D_BASIC_ITEMS_LIS;
			this.$root.genericGetAuthenticatedCallEngine(endpoint2go, this.callbackLoadS3dBasicItemList, 'err.loadingS3dBasicItemsList');
		},
		callbackLoadS3dBasicItemList(responseData)
		{
			if(!this.isEmptyObj(responseData))
			{
				this.s3dBasicItemslist = responseData;
				
			}
			else 
			{
				this.$root.setDialogMsg(i18n.t("err.loadingS3dBasicItemsList"));
			}	
		},
		loadTjsObjList()
		{
			var endpoint2go = constants.ENDPOINT_GATEWAY_TJS_OBJ_LIST;
			this.$root.genericGetAuthenticatedCallEngine(endpoint2go, this.callbackLoadTjsObjList, 'err.loadingThreeJsObjList');
		},
		callbackLoadTjsObjList(responseData)
		{
			if(!this.isEmptyObj(responseData))
			{
				this.tjsobjlist = responseData;
				
			}
			else 
			{
				this.$root.setDialogMsg(i18n.t("err.loadingThreeJsObjList"));
			}	
		},
		loadSiteCategoryItems()
		{
			this.siteCategoryItems = this.getSiteCategoryItems();
		},
        openEditMap()
		{
			this.dialogEditMapIsOpen = true;
		},
		closeEditMap()
		{
			this.dialogEditMapIsOpen = false;
			// DA ERRORE
            //this.map2edit = null;
		},
        editMap()
		{
			if(this.isEmptyString(this.$route.params.orgId))  
			{
				this.$root.setDialogMsg(i18n.t("err.orgSelectedNotValid"));
			}
            else if(this.isEmptyString(this.$route.params.siteid))  
			{
				this.$root.setDialogMsg(i18n.t('err.siteSelectedNotValid'));
			}
			else{
				if (this.$refs.editMapFrm.validate())
				{	
					var endpoint2go = constants.ENDPOINT_GUI_ADMIN_ORGANIZATIONS + '/'+ this.$route.params.orgId + '/sites/'+ this.$route.params.siteid +'/maps';
					if(!this.isEmptyObj(this.map2edit))
					{
						var obj2send = null;
						if(!this.isEmptyString(this.map2edit['sitemap_id']) )
						{
							endpoint2go += '/' +this.map2edit['sitemap_id'];
							
							//alert("CHIAMO PATCH PERCHE EDIT");
							obj2send = {
								'map_asset': this.map2edit['map_asset'],
								'map_asset_type': this.map2edit['map_asset_type'],
								'map_name': this.map2edit['map_name'],
								'map_link': this.map2edit['map_link'],
								'map_db_mask_code': this.map2edit['map_db_mask_code'],
								'flags': this.map2edit['flags']
							};
							if(!this.isEmptyString(this.map2edit['main_obj_pos_x']) )
							{
								obj2send.main_obj_pos_x = this.map2edit['main_obj_pos_x'];
							}
							if(!this.isEmptyString(this.map2edit['main_obj_pos_y']) )
							{
								obj2send.main_obj_pos_y = this.map2edit['main_obj_pos_y'];
							}
							if(!this.isEmptyString(this.map2edit['main_obj_pos_z']) )
							{
								obj2send.main_obj_pos_z = this.map2edit['main_obj_pos_z'];
							}

							if(!this.isEmptyString(this.map2edit['main_obj_scale_x']) )
							{
								obj2send.main_obj_scale_x = this.map2edit['main_obj_scale_x'];
							}
							if(!this.isEmptyString(this.map2edit['main_obj_scale_y']) )
							{
								obj2send.main_obj_scale_y = this.map2edit['main_obj_scale_y'];
							}
							if(!this.isEmptyString(this.map2edit['main_obj_scale_z']) )
							{
								obj2send.main_obj_scale_z = this.map2edit['main_obj_scale_z'];
							}


                            if(!this.isEmptyString(this.map2edit['main_obj_rotation_x']) )
							{
								obj2send.main_obj_rotation_x = this.map2edit['main_obj_rotation_x'];
							}
							if(!this.isEmptyString(this.map2edit['main_obj_rotation_y']) )
							{
								obj2send.main_obj_rotation_y = this.map2edit['main_obj_rotation_y'];
							}
							if(!this.isEmptyString(this.map2edit['main_obj_rotation_z']) )
							{
								obj2send.main_obj_rotation_z = this.map2edit['main_obj_rotation_z'];
							}
                            
							this.$root.genericPatchAuthenticatedCallEngine(endpoint2go, obj2send, this.callbackEditMap, 'err.savingMap');
						} else {
							
							//alert("CHIAMO POST PERCHE CREATE");
							obj2send = this.map2edit;
							this.$root.genericPostAuthenticatedCallEngine(endpoint2go, obj2send, this.callbackEditMap, 'err.savingMap');
						} 
					} 
					else
					{
						this.$root.setDialogMsg(i18n.t('err.payloadNotValid'));
					} 
				}
			}	
		},
		callbackEditMap(responseData) 
		{
			if(!this.isEmptyObj(responseData))
			{
				//console.log(responseData);

				this.dialogEditMapIsOpen= false;
				
				//=== RE-LOAD MAPS
				events.$emit(constants.EVENT_DO_LOAD_MAP_LIST);
                
                this.$root.setDialogMsg(i18n.t('msg.saveok'));
			}
			else 
			{
				this.$root.setDialogMsg(i18n.t("err.savingMap"));
			} 
		},
    }
}
</script>       